var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteIcon02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.708 21.3568H7.29134C4.16634 21.3568 2.08301 19.7943 2.08301 16.1484V8.85677C2.08301 5.21094 4.16634 3.64844 7.29134 3.64844H17.708C20.833 3.64844 22.9163 5.21094 22.9163 8.85677V16.1484C22.9163 19.7943 20.833 21.3568 17.708 21.3568Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.4045C11.625 13.4045 10.7396 13.1337 10.0625 12.5816L6.80205 9.97743C6.46872 9.70659 6.40623 9.21701 6.67706 8.88368C6.94789 8.55034 7.43748 8.48785 7.77081 8.75868L11.0312 11.3628C11.8229 11.9983 13.1666 11.9983 13.9583 11.3628L17.2187 8.75868C17.5521 8.48785 18.0521 8.53993 18.3125 8.88368C18.5833 9.21701 18.5312 9.71701 18.1875 9.97743L14.9271 12.5816C14.2604 13.1337 13.375 13.4045 12.5 13.4045Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon02);
export default __webpack_public_path__ + "static/media/note-icon-02.7b590004fbdcafa6518a5c84c5971080.svg";
export { ForwardRef as ReactComponent };